import React from "react";
import { orderSourceKind, SOURCE_LABEL } from "../lib/orderSource";

/** Small kitchen-readable order-source badge: LOKAL (walk-in) vs ONLINE (customer app). */
export function SourceBadge({ o, className = "" }) {
  const kind = orderSourceKind(o);
  const tone = kind === "local" ? "bg-brand-orange/15 text-brand-orange"
    : kind === "online" ? "bg-sky-100 text-sky-700"
    : "bg-slate-100 text-slate-500";
  return (
    <span data-testid={`source-badge-${o?.order_number}`} data-source-kind={kind}
      className={`text-[10px] font-black uppercase tracking-wider rounded-full px-2 py-0.5 shrink-0 ${tone} ${className}`}>
      {SOURCE_LABEL[kind]}
    </span>
  );
}
